import { render } from "./ThreadShow.vue?vue&type=template&id=2007690e"
import script from "./ThreadShow.vue?vue&type=script&lang=js"
export * from "./ThreadShow.vue?vue&type=script&lang=js"
script.render = render

export default script